import 'react-app-polyfill/stable';
import { SAUX360Theme } from '@saux/design-system-react';
import Amplify from 'aws-amplify'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import getConfig from './aws-exports';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Env } from './utils/constants';
import App from './App';
import './index.css';


const awsExports: any = getConfig(process.env.REACT_APP_ENV as Env);

Amplify.configure(awsExports);
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={SAUX360Theme} >
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
